module.exports = __webpack_public_path__ + "static/media/diy_skyminer_3.1fa71801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/diy_skyminer_3.jpg
// module id = 1445
// module chunks = 0